module.exports = __webpack_public_path__ + "static/media/advertisers_header_background.6670cd41.png";